import { Injectable } from '@angular/core';
import { ApiService } from 'src/app/service/api.service';
import { Router, Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, forkJoin } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ExpenseListService implements Resolve<any> {

  constructor(private api:ApiService,private router:Router) { }
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any{
    return forkJoin([this.api.get('expenseList?orderBy=date_desc,id_desc&start=0&length=10')]);
  }

  erro401Unauth()
  {
    localStorage.clear();
    this.router.navigate(['/login']);

  }
}
